export const duplicateFavoriteDisplayNameTemplate = "AzGVnd";
export default {duplicateFavoriteDisplayNameTemplate};